import Fuse from 'fuse.js';
import ThreeController from './components/threeSetup/threeSetup.js';
import newSearch from './components/search/newSearch.js';
import CatalogueController from './components/search/CatalogueController.js';
import CartController from './components/cart/CartController.js';
import CarouselComponent from './components/threeMeshes/carousel.js';
import countriesData from './countries.json';

// Function to populate the country select
function populateCountrySelect(countries) {
    const countrySelect = document.getElementById('country');
    countries.forEach(country => {
        const option = document.createElement('option');
        option.value = country.code;
        option.textContent = country.name;
        countrySelect.appendChild(option);
    });
}

const threeController = new ThreeController();
threeController.createParticles();

const catalogueController = new CatalogueController(threeController);
const NewSearch = new newSearch(catalogueController);
const carouselComponent = new CarouselComponent(catalogueController);

function openModal() {
    let modal = document.getElementById("imageViewer");
    modal.style.display = "block";
    setTimeout(() => {
        modal.style.backgroundColor = "rgba(0,0,0,0.9)";
        modal.style.opacity = "1";
    }, 50);
}

function closeModal() {
    let modal = document.getElementById("imageViewer");
    modal.style.backgroundColor = "rgba(0,0,0,0)";
    modal.style.opacity = "0";
    setTimeout(() => {
        modal.style.display = "none";
    }, 300);
}

let slideIndex = 1;

function showSlides(n) {
    let slides = document.getElementsByClassName("about-image");
    if (n > slides.length) { slideIndex = 1 }
    if (n < 1) { slideIndex = slides.length }
    document.getElementById("expandedImg").src = slides[slideIndex - 1].src;
}

function plusSlides(n) {
    showSlides(slideIndex += n);
}
window.plusSlides = plusSlides;


document.addEventListener('DOMContentLoaded', function() {
    const language = getCookie('language') || 'eng';
    loadTranslations(language);

    document.querySelector('a[href="?language=eng"]').addEventListener('click', () => {
        document.cookie = "language=eng; path=/";
        loadTranslations('eng');
    });
    document.querySelector('a[href="?language=gr"]').addEventListener('click', () => {
        document.cookie = "language=gr; path=/";
        loadTranslations('gr');
    });

    document.getElementById('floatingCartBtn').addEventListener('click', () => {
        navigateToSection('cart');
    });

    function loadTranslations(language) {
        fetch(`/assets/translations-${language}.json`)
            .then(response => response.json())
            .then(translations => {
                try {
                    const _qs = (sel, val, prop) => {
                        const el = document.querySelector(sel);
                        if (el && val !== undefined) el[prop || 'textContent'] = val;
                    };

                    // ── Nav links ────────────────────────────────────────────────
                    _qs('a[href="#home"]',      translations.home);
                    _qs('a[href="#catalogue"]', translations.catalogue);
                    _qs('a[href="#perfumer"]',  translations.perfumer);
                    _qs('a[href="#about"]',     translations.about);
                    _qs('a[href="#contact"]',   translations.contact);
                    const cartTextEl = document.querySelector('#floatingCartBtn .cart-label');
                    if (cartTextEl) cartTextEl.textContent = translations.cart;

                    // ── Home section ─────────────────────────────────────────────
                    _qs('#center-panel h1',  translations.original_creations);
                    _qs('#center-panel h2',  translations.discover_perfumes);
                    _qs('#center-panelC h1', translations.contact_us);
                    _qs('#center-panelC h2', translations.parosb_hours);
                    _qs('#center-panelC h3', translations.working_hours);
                    _qs('#left-panel h2',    translations.new_catalogue);
                    _qs('#left-panel p',     translations.discover_essence);
                    _qs('#left-panel a',     translations.go_there_now);
                    _qs('#right-panel h2',   translations.try_perfumer);
                    _qs('#right-panel p',    translations.embark_journey);
                    _qs('#right-panel a',    translations.to_the_perfumer);

                    // ── Cart section ─────────────────────────────────────────────
                    _qs('#cart h2',                   translations.your_cart);
                    _qs('#cartTotal',                 translations.total);
                    _qs('#chcktBtn',                  translations.checkout);
                    _qs('#paymentMethodMessage p',    translations.payment_method);
                    _qs('#bankTransferBtn',           translations.bank_transfer);
                    _qs('#cardPaymentBtn',            translations.card_payment);
                    _qs('#shippingCost',              translations.shipping_cost);
                    _qs('#finalCost',                 translations.total_cost);

                    window.catalogueTranslations = translations;

                    const _t = (sel, val, useHTML) => {
                        const el = document.querySelector(sel);
                        if (el && val) { if (useHTML) el.innerHTML = val; else el.textContent = val; }
                    };

                    // ── Catalogue sidebar ────────────────────────────────────────
                    _t('.csb-btn[data-gender="men"]',          translations.men_perfumes);
                    _t('.csb-btn[data-gender="women"]',        translations.women_perfumes);
                    _t('.csb-btn[data-gender="unisex"]',       translations.unisex_perfumes);
                    _t('.csb-btn[data-category="candles"]',    translations.aromatic_candles);
                    _t('.csb-btn[data-category="cstBody"]',    translations.customized_body);
                    _t('.csb-btn[data-category="oliBody"]',    translations.olivaloe_body);
                    _t('.csb-btn[data-category="carrier"]',    translations.carrier_oils);
                    _t('.csb-btn[data-category="essential"]',  translations.essential_oils);
                    _t('.csb-btn[data-category="autFreshers"]',translations.auto_freshers);
                    _t('.csb-btn[data-category="intFreshers"]',translations.interior_freshers);
                    _t('.csb-btn[data-category="moistSkcare"]',translations.moisturizer_skin);
                    _t('.csb-btn[data-category="soapanti"]',   translations.soaps_antiseptics);
                    _t('.csb-btn[data-category="colognes"]',   translations.colognes);

                    // ── Catalogue empty states ───────────────────────────────────
                    _t('#cleText',       translations.select_category_prompt_html, true);
                    _t('#cdpEmptyText',  translations.select_product_prompt_html,  true);
                    _t('#cdpFragLabel',  translations.fragrance_notes);
                    _t('#cdpPriceLabel', translations.price);
                    _t('#cdpFreeSample', translations.free_sample);
                    _t('#cssNotesLabel', translations.notes);
                    _t('#noteText',      translations.catalogue_note);
                    _t('#csb-label-perfumes', translations.perfumes_label);
                    _t('#csb-label-daily',    translations.daily_care_products);

                    // ── Perfumer section ─────────────────────────────────────────
                    _t('#perfSelectCat',  translations.perf_select_cat);
                    _t('#perfChoiceLbl',  translations.perf_choose_pref);
                    _t('#backBtn1',       translations.back);
                    _t('#backBtn2',       translations.back);
                    _t('#srcBtn',         translations.search);
                    if (document.getElementById('searchInputEl'))
                        document.getElementById('searchInputEl').placeholder = translations.search_placeholder;

                    // ── Cart / Samples ───────────────────────────────────────────
                    _t('#freeSamplesTitle', translations.free_samples);
                    _t('#youCanChooseTxt',  translations.you_can_choose);
                    _t('#samplesTxt',       translations.samples_txt);
                    _t('#remainingTxt',     translations.remaining);
                    _t('#addSampleTxt',     translations.add_sample);
                    _t('#payMethodTxt',     translations.pay_method);

                    // ── Payment form ─────────────────────────────────────────────
                    _t('#pfTitle',       translations.pf_title);
                    _t('#pfSubtitle',    translations.pf_subtitle);
                    _t('#pfSumOrder',    translations.pf_order);
                    _t('#pfSumShipping', translations.pf_shipping);
                    _t('#pfSumTotal',    translations.pf_total_due);
                    _t('#pfDivContact',  translations.pf_contact);
                    _t('#pfDivBilling',  translations.pf_billing);
                    _t('#pfLblEmail',    translations.pf_email);
                    _t('#pfLblPhone',    translations.pf_phone);
                    _t('#pfLblFirst',    translations.pf_first_name);
                    _t('#pfLblLast',     translations.pf_last_name);
                    _t('#pfLblCountry',  translations.pf_country);
                    _t('#pfLblState',    translations.pf_state);
                    _t('#pfLblCity',     translations.pf_city);
                    _t('#pfLblZip',      translations.pf_zip);
                    _t('#pfLblStreet',   translations.pf_street);
                    _t('#pfTermsText',   translations.pf_terms);
                    _t('#pfSubmitTxt',   translations.pf_submit);
                    if (document.getElementById('payerEmail'))
                        document.getElementById('payerEmail').placeholder = translations.pf_email_ph;

                    // ── Home search bar ──────────────────────────────────────────
                    _t('#mainSearchByName',  translations.search_by_name);
                    _t('#mainSearchByNotes', translations.search_by_notes);
                    _t('#learnMoreBtn',      translations.learn_more);
                    _t('#searchNameBtn2',    translations.search_by_name);
                    _t('#searchNotesBtn2',   translations.search_by_notes);

                    // ── Perfumer category buttons ────────────────────────────────
                    _t('#perfBtnMen',    translations.perf_men);
                    _t('#perfBtnWomen',  translations.perf_women);
                    _t('#perfBtnUnisex', translations.perf_unisex);

                    // ── Contact page ─────────────────────────────────────────────
                    _t('#contactIntro',     translations.contact_intro);
                    _t('#syrosHours',       translations.syros_hours,   true);
                    _t('#parosIslandTitle', translations.paros_island);
                    _t('#syrosIslandTitle', translations.syros_island);
                    _t('#parosAddress',     translations.paros_address, true);
                    _t('#syrosAddress',     translations.syros_address, true);

                    // ── Samples gender filter ────────────────────────────────────
                    _t('#samplesFilterAll',    translations.all);
                    _t('#samplesFilterMen',    translations.men);
                    _t('#samplesFilterWomen',  translations.women);
                    _t('#samplesFilterUnisex', translations.unisex);

                    // ── Footer ───────────────────────────────────────────────────
                    _t('#footerText', translations.footer_text);

                    // ── Contact section ──────────────────────────────────────────
                    _t('#contactUsTitle',  translations.contact_us);
                    _t('#parosHoursTitle', translations.paros_hours_title);
                    _t('#syrosHoursTitle', translations.syros_hours_title);
                    _t('#cfLblName',       translations.cf_name);
                    _t('#cfLblEmail',      translations.cf_email);
                    _t('#cfLblMessage',    translations.cf_message);
                    _t('#cfSubmitBtn',     translations.cf_submit);
                    _t('#cfThankyou',      translations.cf_thankyou);
                    _t('#cfBack',          translations.cf_back);

                    // ── About section ────────────────────────────────────────────
                    _qs('#about h3:nth-of-type(1)', translations.join_story);
                    _qs('#about p:nth-of-type(1)',  translations.scented_story);
                    _qs('#about h2',                translations.about_us);
                    _qs('#about p:nth-of-type(2)',  translations.our_passion);
                    _qs('#about h3:nth-of-type(2)', translations.our_craft);
                    _qs('#about p:nth-of-type(3)',  translations.our_craft_text);
                    _qs('#about h3:nth-of-type(3)', translations.essence_nature);
                    _qs('#about p:nth-of-type(4)',  translations.essence_nature_text);

                } catch (e) {
                    console.warn('Translation error (non-fatal):', e.message);
                }
            })
            .catch(error => console.error('Error loading translations:', error));
    }

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    populateCountrySelect(countriesData);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('status') === 'success') {
        document.getElementById('paymentSuccess').classList.remove('hidden');
        document.getElementById('orderId').textContent      = urlParams.get('orderId');
        document.getElementById('orderDesc').textContent    = urlParams.get('orderDesc');
        document.getElementById('orderAmount').textContent  = urlParams.get('orderAmount');
        document.getElementById('payerEmail').textContent   = urlParams.get('payerEmail');
    }

    navigateToSection('home');

    const navLinks   = document.querySelectorAll('.nav-menu a');
    const panelLinks = document.querySelectorAll('.background-panel a');

    navLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const sectionId = e.currentTarget.getAttribute('href').slice(1);
            navigateToSection(sectionId);
            e.preventDefault();
            navbar.classList.remove('open');
            menuOverlay.classList.remove('active');
            hamburger.classList.remove('is-active');
        });
    });

    panelLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const sectionId = e.target.getAttribute('href').slice(1);
            navigateToSection(sectionId);
            e.preventDefault();
        });
    });

    var hamburger  = document.querySelector('.hamburger');
    var navbar     = document.querySelector('.navbar');
    var menuOverlay = document.createElement('div');
    menuOverlay.classList.add('menu-overlay');
    document.body.appendChild(menuOverlay);

    hamburger.addEventListener('click', function() {
        navbar.classList.toggle('open');
        menuOverlay.classList.toggle('active');
        this.classList.toggle('is-active');
    });

    menuOverlay.addEventListener('click', function() {
        navbar.classList.remove('open');
        menuOverlay.classList.remove('active');
        hamburger.classList.remove('is-active');
    });

    let images = document.getElementsByClassName("about-image");
    for (let i = 0; i < images.length; i++) {
        images[i].addEventListener('click', function() {
            document.getElementById("expandedImg").src = this.src;
            openModal();
            showSlides(slideIndex);
        });
    }

    document.getElementsByClassName("closeThis")[0].addEventListener('click', function() {
        closeModal();
    });

    const form           = document.getElementById('contactForm');
    const thankYouMessage = document.getElementById('thankYouMessage');
    const formBack       = document.getElementById('formBack');

    form.addEventListener('submit', function(e) {
        e.preventDefault();
        const formData = new FormData(form);
        fetch('./contact.php', { method: 'POST', body: formData })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    alert(data.message);
                    form.style.display = 'none';
                    thankYouMessage.style.display = 'block';
                } else {
                    alert(data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('There was a problem submitting your form. Please try again later.');
            });
    });

    formBack.addEventListener('click', function() {
        form.style.display = 'block';
        thankYouMessage.style.display = 'none';
        form.reset();
    });
});


// ── Section navigation ────────────────────────────────────────────────────

function navigateToSection(sectionId) {
    const currentlyVisibleSection = document.querySelector('.section.visible');
    const sectionToShow           = document.getElementById(sectionId);

    // ── Hide search bar in catalogue and cart — it belongs to home ──
    document.body.dataset.section = sectionId;

    if (threeController.perfumeBottle) {
        threeController.removeCurrentPerfumeBottle();
    }
    if (sectionId === 'contact') {
        if (!document.querySelector('script[src*="recaptcha"]')) {
            const s = document.createElement('script');
            s.src = 'https://www.google.com/recaptcha/api.js';
            s.async = true;
            s.defer = true;
            document.head.appendChild(s);
        }
    }
    const perfumePopup = document.querySelector('.perfume-popup');
    if (perfumePopup) perfumePopup.style.display = 'none';

    const productPopup = document.querySelector('.product-popup');
    if (productPopup) productPopup.style.display = 'none';

    if (currentlyVisibleSection && currentlyVisibleSection.id !== sectionId) {
        currentlyVisibleSection.style.opacity = '0';
        currentlyVisibleSection.addEventListener('transitionend', function transitionOut() {
            this.classList.remove('visible');
            this.removeEventListener('transitionend', transitionOut);
            threeController.particles.models.forEach(model => model.visible = false);
            showNewSection(sectionToShow);
        }, { once: true });
    } else if (sectionToShow && !currentlyVisibleSection) {
        showNewSection(sectionToShow);
    }

    threeController.particles.models.forEach(model => model.visible = true);
    threeController.particles.smokeAnimation();

    setTimeout(() => {
        threeController.particles.models.forEach(model => model.visible = false);
    }, 1000);
}

function showNewSection(sectionToShow) {
    if (sectionToShow) {
        requestAnimationFrame(() => {
            sectionToShow.style.opacity = '1';
            sectionToShow.classList.add('visible');

            if (sectionToShow.id === 'catalogue') {
                const note = document.getElementById('note');
                setTimeout(() => {
                    note.style.display = 'block';
                    note.addEventListener('animationend', function() {
                        note.style.display = 'none';
                    }, { once: true });
                }, 1000);
            }
        });
    }
}

function closeNote() {
    document.getElementById('note').style.display = 'none';
}

window.navigateToSection = navigateToSection;
window.closeNote         = closeNote;